"use strict";

/**
 * Manages all things related to FreeTextSearch
 * Refactored with 2016 release of C21 (Hence "New")
 */
window.NewPortalSearch = function() {
   var self = this;

   // Dependency alias for internationalization library
   var m_internationalization = window.internationalization;

   // Sub-classes
   var m_animator = new FreeTextSearchAnimator();
   var m_suggestions = new FreeTextSearchSuggestions();
   var m_tracking = new FreeTextSearchTracking();
   var m_freeTextSearchHomepage = new FreeTextSearchHomepage();

   // Element references
   var m_jSearchElement; // Search element. Contains inputs, dropdown, etc.
   var m_jUserInput; // Primary search input (where the user types)
   var m_jInlineSuggestion; // Gray text behind the search input
   var m_jClearButton; // Button allowing user to clear search
   var m_jSubmitButton; // Button to perform search

   // Timeout identifiers
   var m_iRequestTimeout; // timeout for requesting suggest dropdown
   var m_iStateTimeout; // timeout for updating dropdown state

   // Default text. Gets populated later, once class is
   // instantiated, by the internationalization library
   // Example: "Search properties, agents and offices..."
   var m_strDefaultText;

   // True if the input is focused. False if blurred.
   var m_bSearchTextFocused;

   // Function to be called when the currently selected item is submitted
   var m_fnOnSubmit;

   // Stores the last search query (ex: "Phoenix, AZ") that was
   // used to display the dropdown. Used to determine whether an AJAX
   // call needs to be made again, or if the dropdown can just be displayed.
   var m_strLastRequest;

   // Key constants
   var KEY_ENTER = 13;
   var KEY_UP = 38;
   var KEY_DOWN = 40;
   var KEY_RIGHT = 39;
   var KEY_TAB = 9;

   // How many characters must the user type in
   // before the results start showing?
   var MINIMUM_LENGTH = 3;

   var mainSearch = $('.homepage-main-search');
   mainSearch.hide();
   if (($(document.body).hasClass("home") || $('.is-homepage').length > 0)) {
	  //$('.carouselitem.jdpower').remove();	   
      if(!$("#MobileTest:visible").length) {
         mainSearch.show();
      } 
   }

   
   /*
   // GA Experiment - Lead Enhancement Modal
   // Using interval because experiment was being set after this was run in rare cases
   function checkLeadEnhancementModal() {
      if (window.gaExperimentInfo) {
         clearInterval(leadEnhancementInterval);
         if(window.gaExperimentInfo.variant == 1 &&
            (window.gaExperimentInfo.id === 'aOFyKjegT6GKkv3ok1Zu2g' || window.gaExperimentInfo.id === 'Y9L1SiK1ToWgbeHccNjO-g')) {
            $('body').addClass('contactModalReskin');
         }
      }
   }
   let leadEnhancementInterval = setInterval(checkLeadEnhancementModal, 100);
   */	

   /**
    * Request a portal search. This will query for the search dropdown, which may then
    * forward the user to the results page.
    *
    * @param {Boolean} bEnterPressed Whether the user pressed enter to trigger the search
    */
   function showResults (bEnterPressed) {
      var strUserInput = m_jUserInput.val();
      var strSuggestType = $("#suggestType").val(); // Element returned with results
      var bIsExactLocationMatch = $("#isExactLocationMatch").val(); // Element returned with results

      // Perform a submit and search for the single location properties or an exact matched location properties
      if (bEnterPressed) {

         switch (strSuggestType) {
            case 'SINGLE_LOCATION':
               if (bIsExactLocationMatch !== 'true') {
                  m_fnOnSubmit = undefined;
                  break;
               }
               var strLid = $("#singleLocationID").val(); // Element returned with results
               if (strLid && strLid.length > 0) {
                  var strSingleLocationType = $("#singleLocationType").val(); // Element returned with results
                  freeTextSearch.gaTrackExactLocationMatch(strLid, strSingleLocationType);
                  freeTextSearch.propertySearch(strLid, 'N', bEnterPressed);
                  return false;
               }
               break;

            // GA Tracking - Exact Match Details (Property/Agent/Office)
            case 'SINGLE_PROPERTY':
               var brandCd = $("#propertyBrandCd").val(); // Element returned with results
               Track.doEvent('Free Text Search', 'Select property details for brand ' + brandCd);
               break;

            case 'SINGLE_AGENT':
               Track.doEvent('Free Text Search', 'Select agent details');
               break;

            case 'SINGLE_OFFICE':
               Track.doEvent('Free Text Search', 'Select office details');
               break;
         }
      }

      if (bEnterPressed || (strUserInput != m_strLastRequest)) {
         if (bEnterPressed && m_fnOnSubmit) {
            m_fnOnSubmit();
         } else {
            m_strLastRequest = strUserInput;

            var strSubView = 'indexView.SuggestSubView';
            var strUrl = '/freetextsearch.c21';
            var strQueryString = 'q=' + encodeURIComponent(strUserInput) + ((bEnterPressed) ? '&e=1' : '');
            var oOptions = {
               loadingIndicator : new TallLoadingIndicator('#innerSearch'),
               cache: true
            };

            portalAjax.doViewEngineAjax(strSubView, strUrl, strQueryString, oOptions);
         }
      } else if (strUserInput === m_strLastRequest) {
         if (!m_bSearchTextFocused) {
            return;
         }

         m_animator.showDropdown();
      }
   }

   /**
    * Should be called when input value is changed.
    *
    * Look at the search input value and update things like:
    * 1) Should the clear button be showing?
    * 2) Should we attempt to perform a search?
    * 3) Should the results be showing?
    */
   function updateDropdownState () {
      var strUserInput = m_jUserInput.val();

      // Empty?
      if (strUserInput.length == 0) {
         // Hide the clear button
         m_jClearButton.removeClass("showing");

         // Hide the dropdown
         m_animator.hideDropdown();
      } else {
         // Show the clear button
         m_jClearButton.addClass("showing");

         var bMeetsMinimumSearchLength = (strUserInput.length >= MINIMUM_LENGTH);

         // #e is a hidden element in the dropdown results
         // Its value is 1 when the user pressed enter
         var bShowingDropdownFromEnterPress = ($("#e").val() === "1");

         if (bMeetsMinimumSearchLength || bShowingDropdownFromEnterPress) {
            // Perform a debounced search
            clearTimeout(m_iRequestTimeout);
            m_iRequestTimeout = setTimeout(showResults, 100, false);
         } else {
            // Hide the dropdown
            m_animator.hideDropdown();
         }
      }
   }

   /**
    * Set the suggestion text raw. No filtering.
    * @param {String} strText
    */
   function setRawInlineSuggestion (strText) {
      m_jInlineSuggestion.val(strText);
   }

   /**
    * Check if a given string is a valid autocomplete of another string
    *
    * === For example ===
    * strWhatTheUserTyped: phoe
    * strSuggestion: Phoenix, AZ
    * returns phoenix, AZ -- MATCH!
    *
    * @param {String} strWhatTheUserTyped
    * @param {String} strSuggestion
    * @return {String|null} Returns a string of the combined elements if valid, otherwise null
    */
   function getAutocompleteText (strWhatTheUserTyped, strSuggestion) {
      var strCombined = strWhatTheUserTyped + strSuggestion.slice(strWhatTheUserTyped.length);
      if (strWhatTheUserTyped.toLowerCase() == strSuggestion.slice(0, strWhatTheUserTyped.length).toLowerCase()) {
         return strCombined;
      } else {
         return null;
      }
   }

   /**
    * Set the suggestion text that shows up behind the primary input in gray
    * Also keep the suggestion text in line with the user input.
    *
    * Matching ex: If user has typed in "phoe" and the suggestion is "Phoenix, AZ", the suggestion will be set to "phoenix, AZ"
    * Non-matching ex: If user has typed in "avocados, tx" and the suggestion is "tamales, or", the suggestion will clear out
    *
    * If the current user input text is empty, defaults to m_strDefaultText
    *
    * @param {String} strSuggestion The suggestion to update to. If undefined, default to current suggestion.
    * @param {Function} fnOnSubmit The function to call when submit is clicked. Should skip disambiguation and jump directly to that result.
    */
   function updateInlineSuggestion (strSuggestion, fnOnSubmit) {
      var strWhatTheUserTyped = m_jUserInput.val();

      if (strWhatTheUserTyped === "" || strWhatTheUserTyped === undefined) {
         m_fnOnSubmit = undefined;
         setRawInlineSuggestion(m_strDefaultText);
         return;
      }

      if (typeof strSuggestion !== "string") {
         strSuggestion = m_jInlineSuggestion.val();
         fnOnSubmit = m_fnOnSubmit;
      } else if (strSuggestion === "") {
         m_fnOnSubmit = undefined;
         setRawInlineSuggestion("");
         return;
      }

      if (strSuggestion.length < strWhatTheUserTyped.length) {
         m_fnOnSubmit = undefined;
         setRawInlineSuggestion('');
         return;
      }

      var strCombined = getAutocompleteText(strWhatTheUserTyped, strSuggestion);
      if (strCombined) {
         setRawInlineSuggestion(strCombined);
         m_fnOnSubmit = fnOnSubmit;
      } else {
         // Try with the current autocomplete text...
         var strCurrentSuggestion = m_jInlineSuggestion.val();
         var strCombined = getAutocompleteText(strWhatTheUserTyped, strCurrentSuggestion);

         // If that also failed
         if (!strCombined) {
            // Clear the submit action and the current suggestion
            m_fnOnSubmit = undefined;
            setRawInlineSuggestion('');
         }
      }
   }

   /**
    * When the search button is clicked
    * @callback fnOnSubmit
    */
   function onSearchButtonClick () {
	  if( ($(document.body).hasClass("home") || $('.is-homepage').length > 0) ) { 
	     Track.doEvent('Homepage', 'Search C21');	   
             freeTextSearch.gaTrackingExperiment('FTS Search Button');
	  } else if($(document.body).hasClass("error")) {
		 Track.doEvent('Page Not Found', 'Search C21');
	  }
      Track.doEvent('Free Text Search', 'Search listings, agents, offices, or locations by Search C21 button click');
      showResults(true);
   }

   /**
    * When the search text is changed
    */
   function onChange () {
      clearTimeout(m_iStateTimeout);
      clearTimeout(m_iRequestTimeout);

      // Prevent animation collision
      m_iStateTimeout = setTimeout(updateDropdownState, 20);
   }

   /**
    * When the search input is focused
    */
   function onFocus () {
      m_jUserInput.select();

      // CR-205 Fix issue where iOS does not honor select() method
      // See: http://stackoverflow.com/questions/3272089/programmatically-selecting-text-in-an-input-field-on-ios-devices-mobile-safari
      var elUserInput = m_jUserInput[0];
      if (elUserInput.setSelectionRange) {
         elUserInput.setSelectionRange(0, 9999);
      }

      m_bSearchTextFocused = true;
      $("#e").val(""); // Clear the enter key stroke event

      m_freeTextSearchHomepage.setAnimated();
      updateDropdownState();
   }

   /**
    * When the search input is no longer focused
    */
   function onBlur () {
      m_bSearchTextFocused = false;
      if ($.trim(m_jUserInput.val()) === '') {
         m_jInlineSuggestion.val(m_strDefaultText);
      }
   }

   /**
    * Set up expanding search results
    *
    * For instance, the user may click on the PLUS sign by properties
    * to show more properties and to hide the agents and offices results.
    */
   function setupExpandingSearchResults () {
      var jExpandingDivs = $("#locationResultsInnerDiv, #propertyResultsInnerDiv, #officeResultsInnerDiv, #agentResultsInnerDiv");

      // Fix click targets for sections
      jExpandingDivs.on("click", function(e) {
         if (e.target != this) return; // only continue if the target itself has been clicked

         var jThis = $(this);
         jThis.find('.moreLinkDiv a, .showLessLinkDiv a').click();
      });

      // Add appropriate styling to sections with no results
      jExpandingDivs.each(function () {
         var jThis = $(this);

         if (jThis.find('div').length === 1) {
            jThis.parent().addClass('noResults');
         }
      });

      jExpandingDivs.not('.noResults').last().addClass("lastExpanding");
   }

   /**
    * Shorten text that doesn't fit on its line
    * (ex: "Phoenix, AZ" may become "Phoenix...")
    */
   function collapseWordsWhereNecessary () {
      $(".ftsCollapse").each(function() {new WordCollapsasaurus($(this));});
   }

   /**
    * Find location of string within another string
    * @param {String} strNeedle  the string to look up (ex: "N 12th St")
    * @param {String} strHaystack the string to look at (ex: "13241 N 12th St, Mesa, AZ")
    * @return {Object} a match with beginning/end character positions (ex: { begin: 6, end: 15 })
    */
   function getHighlightPositions (strNeedle, strHaystack) {
      // Regex to eliminate unnecessary characters
      var regCondense = /([^a-z0-9]| )/gi;

      // Needle without unnecessary characters
      var strNeedleCondensed = strNeedle.replace(regCondense, '').toLowerCase();

      // The beginning / end indexes of a word in the condensed haystack
      var iBeginIndex = 0;
      var iEndIndex = 0;

      var strSearch = '(^|[^a-z0-9])(' + strNeedleCondensed.split('').join('([^a-z0-9]*|[^a-z0-9]+(street|drive|st|rd|blvd|ln)[^a-z0-9]+)?') + ')([^a-z0-9]*)';
      var regSearch = new RegExp(strSearch, 'i');
      var result = strHaystack.match(regSearch);

      if (result !== null) {
         iBeginIndex = result.index;

         if (result[1].length > 0) {
            iBeginIndex++;
         }

         var iTrailHaystack = result[result.length - 1].length;
         var matchTrailNeedle = strNeedle.match(/[^a-z0-9]*$/);
         var iTrailNeedle = 0;
         var iTrail = 0;

         if (matchTrailNeedle !== null) {
            iTrailNeedle = matchTrailNeedle[0].length;
            iTrail = Math.min(iTrailHaystack, iTrailNeedle);
         }

         iEndIndex = result.index + result[0].length - 1 - iTrailHaystack + iTrail;

         return {
            begin: iBeginIndex,
            end: iEndIndex
         };
      }

      return null;
   }

   /**
    * Highlight instances of the search string within all the search results
    */
   function highlightMatchingResults () {
      var strSearch = m_jUserInput.val();
      var jContent = $("#dropdownContent");
      var jAllItems = jContent.find('.ftsHighlight, .ftsHighlightMls');
      var jMlsItems = jContent.find('.ftsHighlightMls');

      // If there's nothing to look for then why bother?
      if ((strSearch).trim() == '') return;

      // Remove previous instances of highlighting
      jContent.find("span.freetextsearchmatched").contents().unwrap();

      jAllItems.each(function(i, el) {
         var jItem = $(el);
         var jCollapsedItem = jItem.find('span span');

         // Sometimes the Collapsasaurus runs before this.
         // We want that to work, but we don't want html
         // mixed up in here
         if (jCollapsedItem.length > 0) {
            jItem = jCollapsedItem.eq(0);
         }

         // Use .text() so as to disregard HTML, &nbsp; or
         // any other funny stuff that could accidentally be highlighted
         var strText = jItem.text();
         var strNewHtml = strText;
         var match = getHighlightPositions(strSearch, strText);

         if (strText == "") return;
         if (match == null) return;

         var iBegin = match.begin;
         var iEnd = match.end - match.begin + 1;

         strNewHtml = strNewHtml.substr(0, iBegin) + "<span class='freetextsearchmatched'>" +
            strNewHtml.substr(iBegin, iEnd) + '</span>' + strNewHtml.substr(iBegin + iEnd);

         jItem.html(strNewHtml);
      });
   }

   /**
    * Handle arrow keys, enter, or normal keypresses
    * @param event
    */
   function onKeyDown (event) {
      switch (event.keyCode) {
         case KEY_ENTER:
            Track.doEvent('Free Text Search', 'Search listings, agents, offices, or locations with enter key');
            showResults(true);
            return false;

         case KEY_RIGHT:
         case KEY_TAB:
            var strBehindText = m_jInlineSuggestion.val();
            if (strBehindText) {
               m_jInlineSuggestion.val('');
               m_jUserInput.val(strBehindText);
               onChange();
               return false;
            }
            break;

         case KEY_UP:
            m_suggestions.moveUp();
            return false;

         case KEY_DOWN:
            m_suggestions.moveDown();
            return false;

         default:
            onChange();
            break;
      }
   }

   /**
    * When the clear button is clicked
    */
   function onClearButtonClick () {
	  Track.doEvent('Free Text Search', 'Reset Search');
      setText("", "");
      onChange();
      m_jUserInput.focus();
      updateInlineSuggestion();
   }

   /**
    * Set the search value
    * @callback fnSetText
    * @param {String} strText The search text to display
    * @param {String} strSuggestion The gray suggestion behind the text to display
    * @param {Function} onSubmit The function to call when submitted. Cleared when text is changed. See CR-109 and CR-206.
    */
   function setText (strText, strSuggestion, onSubmit) {
      m_jUserInput.val(strText);
      updateInlineSuggestion(strSuggestion, onSubmit);
   }

   /**
    * Setup the homepage, if this is the homepage
    * @see FreeTextSearchHomepage
    */
   function attemptHomepageSetup () {
      if ( ($(document.body).hasClass("home") || $('.is-homepage').length > 0) || $(document.body).hasClass("error")) {
         m_freeTextSearchHomepage.initialize(m_jSearchElement, m_jUserInput, onSearchButtonClick, setText);
      }
   }

   /**
    * Literally what it says. Cleaning up junk HTML from the page.
    */
   function cleanupJunk () {
      // We are currently prevented from removing these from the source HTML, but these elements waste time when inspecting the page
      // TODO: After español site no longer requires these elements to be present, remove them
      $("#dropdownRepeat, #dropdownResultsTop, #dropdownRepeat, #dropdownContentTop, #dropdownContentRepeat, #dropdownResultsBottom").remove();
   }

   return {
     createSearchField: function () {
        m_strDefaultText = m_internationalization.getString('Search homes & agents');

        // Setup user input field
        m_jUserInput = $('#searchText');
        m_jUserInput.on('focus', onFocus);
        m_jUserInput.on('blur', onBlur);

        m_jUserInput.on('keydown', onKeyDown);
        m_jUserInput.on('change', onChange);
        m_jUserInput.on('keydown keyup', function () {
           // Don't pass this function directly into jQuery
           // This function accepts params and may misinterpret them
           updateInlineSuggestion();
        });
         m_jUserInput.addClass('searchValue');

         // Setup inline suggestion
         m_jInlineSuggestion = $('#behindSearchText');

         // Setup submit button
         m_jSubmitButton = $('#searchButton');
         m_jSubmitButton.on("click", onSearchButtonClick);

         // Setup clear button
         m_jClearButton = $('.ftsClear');
         m_jClearButton.on("click", onClearButtonClick);

         // Setup search parent
         m_jSearchElement = $("#dropdown");
         m_jSearchElement.on("dropdown-close", m_animator.hideDropdown);

         attemptHomepageSetup();
         cleanupJunk();
         m_suggestions.initialize();
      },

      showSearchDrop: function () {
         m_animator.showDropdown();
         collapseWordsWhereNecessary();
         highlightMatchingResults();
         setupExpandingSearchResults();
         ImageLazyLoader.loadImages();
      },

      hideSearchDrop: m_animator.hideDropdown,

      setText: setText,

      /**
       * Set the suggestion text that shows up behind the primary input in gray
       */
      setBehindText: updateInlineSuggestion,

      // Tracking methods
      pushC21Listing: m_tracking.pushC21Listing,
      pushOffice: m_tracking.pushOffice,
      pushAgent: m_tracking.pushAgent,

      trackListings: m_tracking.trackListings,
      trackAgents: m_tracking.trackAgents,
      trackOffices: m_tracking.trackOffices,

      // Maintained for backwards compatibility
      // As of Apr 26th, 2016 this is called from uiBindings/searchBoxFormat.jsp
      // TODO: After redesign find out what this was supposed to do and remove if possible
      formatSearchResults: function () {},

      // Unsure if this is actually being used. Look into either documenting or removing
      // ~ Lee Bradley (April 29th, 2016)
      handleHash: function (params) {
         m_jUserInput.val(params['q']);
         showResults();
      }
   };
};

/**
 * Handles results navigation (hover and keyboard)
 * Subclass of NewPortalSearch
 */
function FreeTextSearchSuggestions () {
   var m_jSearchDrop;
   var m_iHighlightedIndex;
   var m_jResults;

   /**
    * For a given item in the list, find the text
    * @return {string} ex: "New York, NY"
    */
   function getItemText (jItem) {
      var jItemName;

      if (jItem.hasClass('suggestCollapse') || jItem.hasClass('ftsCollapse')) {
         jItemName = jItem;
      } else {
         jItemName = jItem.find('.suggestCollapse,.ftsCollapse').eq(0);
      }

      // Collapsasaurus will collapse the HTML and set the title,
      // but it doesn't necessarily happen before this is called
      var str = jItemName.attr('title') || jItemName.html();

      return str;
   }

   /**
    * Get a sensible name for the type of drop-down being displayed
    * @return {String} suggest | result | noresults | disambiguation
    */
   function getDropDownType() {
      var strSuggestType = $("#suggestType").val();
      switch (strSuggestType) {
         case "NO_SUGGEST":
            return 'suggest';
            break;
         case "SINGLE_LOCATION":
            return "result";
            break;
         case "NO_RESULT":
            return "noresults";
            break;
         default:
            return "disambiguation";
      }
   }

   function getItemCallback (jItem) {
      return function () {
         jItem.parent().click();
      };
   }

   /**
    * Highlight the item at the specified index
    * @param {Number} i the index to highlight
    */
   function setHighlightedIndex(iHighlightedIndex, bUpdateText) {
      var jItem = m_jResults.eq(iHighlightedIndex);
      var strNewText = getItemText(jItem);

      if (strNewText) {
         strNewText = $.trim(strNewText.split("|")[0]);
      }

      m_jResults.eq(m_iHighlightedIndex).removeClass('hover');
      jItem.addClass('hover');
      m_iHighlightedIndex = iHighlightedIndex;

      if (bUpdateText) {
         portalSearch.setText(strNewText, strNewText, getItemCallback(jItem));
      } else {
         portalSearch.setBehindText(strNewText, getItemCallback(jItem));
      }
   }

   /**
    * Get the index of the currently highlighted item
    */
   function getHighlightedIndex () {
      return m_iHighlightedIndex;
   }

   /**
    * When the "Suggest" section is loaded
    */
   function onSuggestLoad () {
      // Highlight every other item
      m_jResults = m_jSearchDrop.find('#searchBody .result');

      m_jResults.on('mouseenter', function() {
         setHighlightedIndex(m_jResults.index($(this)));
      }).on('mouseleave', function() {
         $(this).removeClass('hover');
      });

      m_iHighlightedIndex = -1;

      var jItem;
      if (m_jResults.length > 0) {
         jItem = m_jResults.eq(0);
         portalSearch.setBehindText(getItemText(jItem), getItemCallback(jItem));
      } else {
         jItem = m_jSearchDrop.find('#singleSearchMatch');
         portalSearch.setBehindText(jItem.text(), getItemCallback(jItem));
      }
   }

   return {
      initialize: function () {
         m_jSearchDrop = $('#dropdownContent');
         portalAjax.bindLoadEvent(m_jSearchDrop, onSuggestLoad);
         m_jSearchDrop.on("click", function(e) { // Prevent clicking in midding of FTS results from closing box
            e.preventDefault();
            return false;
         });
      },

      moveUp: function() {
         if (getDropDownType() != 'suggest')
            return;

         var i = getHighlightedIndex() - 1;

         if (i < 0) {
            i = m_jResults.length - 1;
         }

         setHighlightedIndex(i, true);
      },

      moveDown: function() {
         if (getDropDownType() != 'suggest')
            return;

         var i = getHighlightedIndex() + 1;

         if (i == m_jResults.length) {
            i = 0;
         }

         setHighlightedIndex(i, true);
      }
   };
};

/**
 * Handles SearchDrop Animation
 * Subclass of NewPortalSearch
 */
function FreeTextSearchAnimator () {
   var m_jDropdownContent;
   var m_jDropdownSearchContent;
   var m_iSpeed = 150;
   var m_jSearchBox;
   var m_bInitialized;
   /**
    * Show the content inside of the search box
    */
   function showDropdown () {
      lazyInit();

      m_jDropdownSearchContent.show();
      m_jDropdownContent.slideDown(m_iSpeed, 'easeOutCubic', function() {
         setTimeout(function() {
            // hasLayout fix for IE7
            m_jDropdownContent.css({
               zoom: 1
            });
         }, 1);
      });

      m_jSearchBox.addClass('expanded');
      m_jSearchBox.addClass("c21-dropdown-open");
      activateWordCollapsasaurus();
   }

   function hideDropdown () {
      // Clear the enter key stroke event
      $("#e").val("");
      $("#singleLocationID").val("");
      $("#suggestType").val("");

      lazyInit();

      m_jDropdownSearchContent.hide();
      m_jDropdownContent.hide();
      m_jSearchBox.removeClass('expanded');
      m_jSearchBox.removeClass('c21-dropdown-open');
   }

   function activateWordCollapsasaurus () {
      $('.suggestCollapse').each(function() {
         new WordCollapsasaurus($(this));
      });
   }

   /**
    * Add the onblur event that hides the search box
    */
   function addOnBlurEvent () {
      $(document).on("click", function(e) {
         var jClicked = $(e.target);
         var bIsChildOfSearchBox = (jClicked.parents().filter(m_jSearchBox).length > 0);
         var iOS = /iPad|iPhone|iPod/.test(navigator.userAgent) && !window.MSStream;
         if ((e.target == m_jSearchBox.get(0)) || bIsChildOfSearchBox) {
            e.stopPropagation();
            return;
         }
         //Only apply to iOS tablets
         if(iOS && window.innerWidth >= 768) {
             var homeTopPanel = $('#homepage-top-panel');
             homeTopPanel.css("position", "fixed");
         }

         hideDropdown();
      });
   }

   /**
    * A lazy initialization function, only called when needed
    */
   function lazyInit () {
      // Do not initialize more than once
      if (m_bInitialized)
         return;

      m_bInitialized = true;
      m_jDropdownContent = $("#dropdownContent");
      m_jDropdownSearchContent = $("#dropdownSearchContent");

      m_jSearchBox = $('#dropdown');
      addOnBlurEvent();
   }

   return {
      hideDropdown : hideDropdown,
      showDropdown : showDropdown
   }

}

/**
 * Handles search tracking
 * Subclass of NewPortalSearch
 */
function FreeTextSearchTracking () {
   // Populated through push calls and used for tracking
   var m_aC21ListingGuids = [];
   var m_aC21Listings = [];
   var m_aAgents = [];
   var m_aOffices = [];

   /**
    * Add an agent to track
    */
   function pushAgent (key){
      m_aAgents.push(key);
   }

   /**
    * Add an office to track
    */
   function pushOffice (key){
      m_aOffices.push(key);
   }

   /**
    * Add a listing to track
    */
   function pushC21Listing (listingkey, listingGUID){
      // If the key does not contain CBR, ERA or LCE...
      if (listingkey.indexOf("CBR") < 0 && listingkey.indexOf("ERA") < 0 && listingkey.indexOf("LCE") < 0) {
         m_aC21Listings.push(listingkey.replace("C21", ""));
         m_aC21ListingGuids.push(listingGUID);
      }
   }

   /**
    * Track Agents
    */
   function trackAgents () {
      if (m_aAgents.length == 0) return;
      trackInternally(m_aAgents, 'agent');
   }

   /**
    * Track Offices
    */
   function trackOffices () {
      if (m_aOffices.length == 0) return;
      trackInternally(m_aOffices, 'office');
   }

   /**
    * Track Listings
    */
   function trackListings () {
      if (m_aC21Listings.length == 0) return;

      trackInternally(m_aC21Listings, 'listing');

      // Check ListHub browser compatibility
      var bIsInternetExplorer7 = ($.browser.msie && parseInt($.browser.version) == 7);
      if (!bIsInternetExplorer7) {
         // Continue to ListHub tracking
         $.each(m_aC21ListingGuids, function(i, c21Listing) {
            listHub.doTrackingC21(c21Listing, 'SEARCH_DISPLAY');
         });
      }
   }

   /**
    * Send an AJAX request to internally track items
    *
    * @param aItemIds         the ids of items to be tracked
    * @param strTrackingType  the type of item being tracked ('agent', 'listing', etc)
    */
   function trackInternally (aItemIds, strTrackingType) {
      // Track internally
      var strItemIds = "id=" + aItemIds.join("&id=");
      portalAjax.report({
         url: "/reporting/" + strTrackingType,
         data: strItemIds + "&type=RetSearch"
      });
   }

   return {
      pushC21Listing: pushC21Listing,
      pushOffice: pushOffice,
      pushAgent: pushAgent,

      trackListings: trackListings,
      trackAgents: trackAgents,
      trackOffices: trackOffices,
   }
}

/**
 * Handles homepage functionality
 * Subclass of NewPortalSearch
 */
function FreeTextSearchHomepage () {
   var m_bInitialized = false;
   var m_jHomepageContainer;

   var m_jHomepageMainSearch;
   var m_jHomepageWrapper;
   var m_jWindow;
   var m_jBody;
   var m_jSearchElement;
   var m_jUserInput;
   var m_fnSetText;

   // This is unfortunately necessary at this point, since the HTML can not be edited
   var SCREEN_PHONE_MAX = 767;
   var m_bShowingHomepageMobile = true;
   function hackishMobileHomepageFix () {
      var iWidth = m_jWindow.width();
      if (iWidth > SCREEN_PHONE_MAX) {
         if (!m_bShowingHomepageMobile) return;
         m_jHomepageWrapper.append(m_jSearchElement);
         m_bShowingHomepageMobile = false;
         m_jHomepageMainSearch.addClass("showing-search");
         m_jHomepageMainSearch.css({"display": "block"});
      } else {
         if (m_bShowingHomepageMobile) return;
         m_jHomepageMainSearch.removeClass("showing-search");
         m_jHomepageContainer.append(m_jSearchElement);
         m_bShowingHomepageMobile = true;
         m_jHomepageMainSearch.css({"display": ""});
      }
   }

   // 404 page: This is unfortunately necessary at this point, since the HTML can not be edited
   // The search box would be in the header for mobile view. And, in the center of the page for desktop.
   var m_bShowingErrorpageMobile = true;
   function positionErrorpageSearchDropdown() {
      var iWidth = m_jWindow.width();
      if (iWidth > SCREEN_PHONE_MAX) {
         if (!m_bShowingErrorpageMobile) return;
         m_jHomepageWrapper.append(m_jSearchElement);
         m_bShowingErrorpageMobile = false;
         m_jHomepageMainSearch.addClass("showing-search");
         m_jHomepageMainSearch.css({"display": "block"});
      } else {
         if (m_bShowingErrorpageMobile) return;
         m_jHomepageMainSearch.removeClass("showing-search");
         m_jHomepageContainer.append(m_jSearchElement);
         m_bShowingErrorpageMobile = true;
         m_jHomepageMainSearch.css({"display": ""});
      }
   }
   
   var HEADER_HEIGHT = 91;
   var HOMEPAGE_TOP_IMAGE_HEIGHT = 152;
   var ACTION_LINK_HEIGHT = 108;
   var SEARCH_BOX_HEIGHT = 50;
   var DROPDOWN_HEIGHT_MAX = 500;
   var MIN_HEIGHT_TOSHOW_TOP_IMAGE = HEADER_HEIGHT + HOMEPAGE_TOP_IMAGE_HEIGHT + SEARCH_BOX_HEIGHT + DROPDOWN_HEIGHT_MAX;
   function positionHomepageSearchDropdown () {
      hackishMobileHomepageFix();

      var iHeight = m_jWindow.height();
      // if (iHeight < MIN_HEIGHT_TOSHOW_TOP_IMAGE) {
      //    $(document.body).addClass("no-header-image");
      // } else {
      //    $(document.body).removeClass("no-header-image");
      // }

      $(document.body).addClass("no-header-image");

   }

   function onLocationData (strLocation, strUrl) {
      var v = $.trim(m_jUserInput.val());
      if (v == '') {
         m_fnSetText(strLocation, strLocation, function () {
            window.location.href = strUrl;
         });
      }

      $("#free-text-search-input").val(strLocation);
   }

   return {
      /**
       * Fire up the homepage search
       *
       * @param {jQuery} jSearchElement the parent element for search
       * @param {jQuery} jUserInput the input element for search
       * @param {fnOnSubmit} fnOnSubmit callback for submitting search
       * @param {fnSetText} fnSetText callback for updating the search state
       */
      initialize: function (jSearchElement, jUserInput, fnOnSubmit, fnSetText) {
         m_bInitialized = true;

         // No sense in querying for these again, since they're
         // already fetched by the parent class
         m_jHomepageContainer = $("#dropdown-homepage-container");
         m_jSearchElement = jSearchElement;
         m_jUserInput = jUserInput;

         m_fnSetText = fnSetText;

         m_jHomepageMainSearch = $(".homepage-main-search");
         m_jHomepageWrapper = $(".homepage-input-wrapper");

         // We'll be using these later
         m_jWindow = $(window);
         m_jBody = $(document.body);

         if( ($(document.body).hasClass("home") || $('.is-homepage').length > 0) ) { // home page
             m_jWindow.on('resize', positionHomepageSearchDropdown);
             positionHomepageSearchDropdown();
         } else if($(document.body).hasClass("error")) { // 404 page
             m_jWindow.on('resize', positionErrorpageSearchDropdown);
             positionErrorpageSearchDropdown();        	 
         }

         $("#free-text-search-button").on('click', fnOnSubmit);

         $(document).on('locationset', function (e, oLocation) {
            var strDisplayName = oLocation.displayname;
            var strSearchUrl = oLocation.homesforsaleurl;
            onLocationData(strDisplayName, strSearchUrl);
         });
      },

      setAnimated: function () {
         var iOS = /iPad|iPhone|iPod/.test(navigator.userAgent) && !window.MSStream;
         var homeTopPanel = $('#homepage-top-panel');
         if (!m_bInitialized) return;
            m_jHomepageMainSearch.addClass("animated");
         //Should only do this on iOS tablets
         if(iOS && window.innerWidth >= 768) {
            $('body').scrollTop(0);
            //iOS hates fixed elements
            homeTopPanel.css("position", "absolute");
         }


         var jBody = $(document.body);
         if (!jBody.hasClass("search-focused")) {
            // When the user selects the input, iOS attempts to scroll to that input's INITIAL position.
            // But our input is animating to a position near the top.
            // Workaround: Immediately move the input all the way to the top
            m_jUserInput.css({
               position: "fixed",
               top: 0,
               left: 0,
               opacity: 0
            });

            // iOS CSS animations are deferred during scrolling.
            // Bad iOS. No scrolling. Shame.
            // We need to wait for this to pass.
            setTimeout(function () {
               // Start the 300ms CSS animation
               jBody.addClass("search-focused");

               // iOS gets even more waiting time because
               // otherwise animations will fail miserably

               setTimeout(function () {
                  // Switch focus back on the initial input
                  m_jUserInput.css({
                     position: "",
                     top: "",
                     left: "",
                     opacity: ""
                  });
               }, (iOS) ? 2000 : 1);
            }, 500);
        } else {

        }
      }
   };
}
